module.exports = __webpack_public_path__ + "img/texiao-_0000s_0020_21.18267b7e.png";